/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Stack,
    Paper,
    Checkbox,
    Typography,
    Divider,
    Grid,
    Box
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import AddIcon from '@mui/icons-material/Add';

import Layout from "../../../components/layout/Layout";
import InputText from "../../../components/form/InputText";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Skeleton from "../../../components/form/Skeleton";
import validator from "./validator";
import Table from "../../../components/form/Table";
import PermisesModal from "./PermisesModal";
import { useCanView } from "../../../config/hook/UserPermissions";
import LogsModal from "./LogsModal";
import HistoryIcon from '@mui/icons-material/History';

import { getProfileId } from "../../../store/config/thunk/profile/getId";
import { postProfile } from "../../../store/config/thunk/profile/post";
import { putPermise } from "../../../store/config/thunk/profile/putPermise";
import { getPermise } from "../../../store/config/thunk/profile/getAllPermises";
import { postPermise } from "../../../store/config/thunk/profile/postPermise";
import { getLog } from "../../../store/config/thunk/log/getAll";

const NewEdit = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("usersProfiles");
    const { id } = useParams();
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
    const [selected, setSelected] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalLog, setOpenModalLog] = useState(false);
    const canView = useCanView();

    const current = useSelector(state => state.config.profile.detail);
    const post = useSelector(state => state.config.profile.post);
    const putPermises = useSelector(state => state.config.profile.putPermise);
    const postPermises = useSelector(state => state.config.profile.postPermise);
    const permises = useSelector(state => state.config.profile.permises);
    const put = useSelector(state => state.masters.costGlobal.put);

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const GetData = () => {
        dispatch(getProfileId({ id }));
        dispatch(getPermise({ id }));
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                type: "default",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); navigate(`/config/userProfile/${get(post, "id")}`); }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
        if (get(putPermises, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" }); GetData(); }
        if (get(putPermises, "isReject", false)) { setError(get(putPermises, "error", {}), "put") }
        if (get(postPermises, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); setOpenModal(false); GetData(); }
        if (get(postPermises, "isReject", false)) { setError(get(postPermises, "error", {}), "post") }
    }, [putPermises, post, postPermises])

    useEffect(() => {
        if (!!id) {
            let Screen = "PERFILES"
            dispatch(getLog({page: 1, docId: Number(id), screen: String(Screen)}))
            GetData();
            }
    }, [dispatch, id])

    const onSubmit = (values) => {
        const body = {
            nameProfile: String(get(values, "name")).toUpperCase()
        }
        dispatch(postProfile(body))
    }

    const handleChecked = (event, row, key) => {
        const isChecked = event.target.checked; 
        const updatedRow = { ...row, [key]: isChecked };
        if (canView("CONFIGURACIÓN/PERFILES", "update")) {
            dispatch(putPermise(updatedRow));
        } else {
            setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para actualizar el perfil.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
        }
    };

     const HandlePermise = (permiseSelected) => {
        dispatch(postPermise(permiseSelected));
      }

    const isSelected = (id, key) => selected.some(item => item.id === id && item[key]);

    const headTable = [
        {
          key: "screen",
          label: __(`table.cols.screen`),
          align: "center", 
          sx: { width: "250px" },
        },
        {
          key: "watch",
          label: __(`table.cols.watch`),
          align: "center"
        },
        {
            key: "add",
            label: __(`table.cols.add`),
            align: "center"
        },
        {
            key: "update",
            label: __(`table.cols.update`),
            align: "center"
        },
        {
            key: "delete",
            label: __(`table.cols.delete`),
            align: "center"
        }
      ]
    
      const dataTable = map(get(current, "data.detailPermises", []), (row, i) => ({
        ...row,
        watch: (
            <Checkbox
                color="primary"
                checked={get(row, "watch", false)}
                onChange={(e) => handleChecked(e, row, "watch")}
            />
        ),
        add: (
            <Checkbox
                color="primary"
                checked={get(row, "add", false)} 
                onChange={(e) => handleChecked(e, row, "add")}
            />
        ),
        update: (
            <Checkbox
                color="primary"
                checked={get(row, "update", false)}
                onChange={(e) => handleChecked(e, row, "update")} 
            />
        ),
        delete: (
            <Checkbox
                color="primary"
                checked={get(row, "delete", false)} 
                onChange={(e) => handleChecked(e, row, "delete")} 
            />
        ),
      }))

    const initialValues = {
        name: id ? get(current, "data.nameProfile", "") : ""
    }

    return (
        <Layout
            propsToolbar={{
                title: !id ? __(`head.new.name`) : __(`head.edit.name`),
                srute: !id ? __(`head.new.code`) : id
            }}
        >
            {get(current, "isLoading")
                ? (
                    <Skeleton />
                ) : (
                    <Formik initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                        {formik => (
                            <form onSubmit={get(formik, "handleSubmit")}>
                                <Paper className='p-4'>
                                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                                        { id ? 
                                            <Button
                                            className="w-[150px] min-w-[150px]"
                                            variant="outlined"
                                            color="secondary"
                                            startIcon={< HistoryIcon/>}
                                            onClick={() => {
                                                if (canView("CONFIGURACIÓN/PERFILES/LOGS", "watch")) {
                                                    setOpenModalLog(true)
                                                } else {
                                                    setAlert({
                                                        open: true,
                                                        title: "Permiso Denegado.",
                                                        subtitle: (<ul> • No tienes permiso para ver las modificaciones en perfiles.</ul>),
                                                        type: "error",
                                                        btn: __(`${module}.actions.close`),
                                                        func: closeAlert
                                                    })
                                                }
                                            }}
                                            >
                                            Ver Cambios
                                            </Button> : (<div></div>)
                                        }
                                    {!id && (
                                        <LoadingButton 
                                            className='w-[100px] min-w-[100px]' 
                                            variant="contained" 
                                            color="secondary" 
                                            type="submit" 
                                            loading={get(post, "isLoading") || get(put, "isLoading")}
                                        >
                                            {__(`action.save`)}
                                        </LoadingButton>
                                    )} 
                                    <Button className='w-[100px] min-w-[100px]' variant='outlined' color="secondary" onClick={() => navigate("/config/userProfile")} disabled={get(post, "isLoading") || get(put, "isLoading")} >{__(`action.cancel`)}</Button>
                                    </Stack>
                                </Paper>
                                <Paper className='mt-4'>
                                    <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                        <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                    </Stack>
                                    <Divider />
                                    <Box className='p-4' >
                                        <Grid container spacing={{ xs: 2, md: 3 }} alignItems="center">
                                            <Grid item xs={12} sm={6}>
                                                <InputText
                                                    formik={formik}
                                                    name="name"
                                                    label={__(`form.name.label`)}
                                                    placeholder={__(`form.name.placeholder`)}
                                                    disabled={!!id || get(current, "isLoading", false) || get(post, "isLoading", false) || get(put, "isLoading", false)}
                                                    />
                                            </Grid>
                                            {id && (
                                                <Grid item xs={12} sm={6}>
                                                    <Typography variant="subtitle1" gutterBottom>
                                                        &nbsp;
                                                    </Typography>
                                                    <LoadingButton 
                                                        className='w-[200px] min-w-[150px]' 
                                                        variant="contained" 
                                                        color="secondary"
                                                        startIcon={<AddIcon />} 
                                                        onClick={ () => { 
                                                            if (canView("CONFIGURACIÓN/PERFILES/ASIGNAR PERMISO", "add")) {
                                                                setOpenModal(true); 
                                                            } else {
                                                                setAlert({
                                                                    open: true,
                                                                    title: "Permiso Denegado.",
                                                                    subtitle: (<ul> • No tienes permiso para asignarle permiso al perfil.</ul>),
                                                                    type: "error",
                                                                    btn: __(`${module}.actions.close`),
                                                                    func: closeAlert
                                                                  })
                                                            }
                                                        }}
                                                        loading={get(post, "isLoading") || get(put, "isLoading")}
                                                        disabled={get(permises, "data").length === 0}
                                                    >
                                                        Agregar Permiso
                                                    </LoadingButton>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                </Paper>
                                {id && (
                                <Paper className='mt-4'>
                                    <Stack className='p-4' direction="row" spacing={2} justifyContent="center">
                                        <Typography component="h4" variant="h4">{__(`labels.2`)}</Typography>
                                    </Stack>
                                    <Table headTable={headTable}
                                        dataTable={dataTable}
                                        __={__}
                                        sizeFilters={125}
                                        loading={get(current, "isLoading", false)}
                                    />
                                </Paper>
                                )}
                                <LogsModal
                                    __={__}
                                    open={openModalLog}
                                    close={() => setOpenModalLog(false)}
                                />
                                <PermisesModal
                                    __={__}
                                    open={openModal}
                                    close={() => setOpenModal(false)}
                                    permise = {HandlePermise}
                                />
                            </form>
                        )}
                    </Formik>
                )}
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Layout>
    )
}

export default NewEdit